import {
  COMPANY_CONTACTS_CACHE_UPDATE,
  GET_CONTACTS_REQUEST,
  GET_CONTACTS_SUCCESS,
  GET_CONTACTS_SUCCESS_UNBATCHED,
  GET_CONTACTS_FAILED,
  SET_BULK_DATA,
  CLEAR_BULK_DATA,
  LOGOUT,
} from 'actions';
import update from 'immutability-helper';
import createReducer from './createReducer';

type BulkImportData = {
  contacts: any[];
  companies: any[];
};

interface ContactState {
  contactCacheUpdate: number;
  loading: boolean;
  loaded: boolean;
  bulkImportData: BulkImportData | null;
}

const INITIAL_STATE: ContactState = {
  contactCacheUpdate: 0,
  loading: false,
  loaded: false,
  bulkImportData: {
    contacts: [],
    companies: [],
  },
};

type DataAction = {
  type: string;
  data?: BulkImportData;
};

export default createReducer(INITIAL_STATE, {
  /*
    This state is solely to notify components relying on the webworker generated cache of the company / contact
    mapping that the cache has been updated so they can trigger a re-render.
  */
  [COMPANY_CONTACTS_CACHE_UPDATE]: (state) => ({
    ...state,
    contactCacheUpdate: state.contactCacheUpdate + 1,
  }),
  [GET_CONTACTS_REQUEST]: (state) => ({ ...state, loading: true }),
  [GET_CONTACTS_SUCCESS]: (state) => ({
    ...state,
    loading: false,
    loaded: true,
  }),
  [GET_CONTACTS_SUCCESS_UNBATCHED]: (state) => ({
    ...state,
    loading: false,
    loaded: true,
  }),
  [GET_CONTACTS_FAILED]: (state) => ({ ...state, loading: false }),
  [CLEAR_BULK_DATA]: (state) => ({ ...state, bulkImportData: null }),
  [SET_BULK_DATA]: (state, action?: DataAction) => {
    const data = action?.data;
    if (data === undefined) {
      return state;
    }
    return update(state, {
      bulkImportData: {
        $set: data,
      },
    });
  },
  [LOGOUT]: () => ({ ...INITIAL_STATE }),
});
